export const DEFAULT_PROFILE_PIC =
  "https://exly-public-content.s3.ap-south-1.amazonaws.com/creator-tool/public/default_user_profile_image.png";

export const GROUP_KEYS = {
  uuid: "uuid",
  name: "name",
  isDefault: "is_default",
  priority: "priority",
  channels: "channels",
};

export const CHANNEL_KEYS = {
  name: "name",
  priority: "priority",
  isEmailNotifEnabled: "is_email_notif_enabled",
  isAppNotifEnabled: "is_app_notif_enabled",
  metadata: "metadata",
  icon: "icon",
  uuid: "uuid",
  isEnabled: "is_enabled",
  channelType: "channel_type",
  allowEndUserPost: "allow_end_user_post",
  accessType: "access_type",
  lockMessage: "lock_message",
  coverImage: "cover_image",
  enable_comments: "enable_comments",

  // extra keys from backend
  unreadCount: "unread_count",
  hasUnreadMention: "has_unread_mention",
};

export const DUMMY_CHANNEL_KEYS = {
  CHANNEL_DATA: "channel_data",
};

export const COMMUNITY_VIEW_SETTINGS_KEYS = {
  enable_feed_comments: "enable_feed_comments",
};
